import React from "react";
import "./Shop_by_shapes_cards.css";
import Like_heart_btn_holder from "../Like_heart_btn_holder/Like_heart_btn_holder";
import HeartIconComponent from "../HeartIconComponent/HeartIconComponent";
import { Link } from "react-router-dom";
import { encodeId } from "../../../utils/common";

function Shop_by_shapes_cards({ val }) {
  

  return (
    <section className="Shop_by_shapes_cards">
      <div className="Shop_by_shapes_cards_heart">
        <Link to={`/product-details-page/${encodeId(val?.id)}`}>
          <div className="shapes_cards_img_holder">
            {/* <img
              src={
                process.env.REACT_APP_IMG_URL + val?.Product_Images[0]?.image ||  process.env.REACT_APP_IMG_URL + val?.Product?.Product_Images[0]?.image 
              }
              className="shapes_cards_img"
              alt="shapes_cards_img"
            /> */}
            <img
              src={
                process.env.REACT_APP_IMG_URL +
                (val?.Product_Images?.[0]?.image ??
                  val?.Product?.Product_Images?.[0]?.image ??
                  "default.png") // optional fallback
              }
              className="shapes_cards_img"
              alt="shapes_cards_img"
            />
          </div>
        </Link>

        <div className="Heart_btn">
          <HeartIconComponent
            combination_id={val.combination_id}
            product_id={val?.id}
          />
        </div>
      </div>
      <Link to={`/product-details-page/${encodeId(val?.id)}`}>
        <div className="text_holder">
          <h4>{val?.Product?.name || val?.name}</h4>

          {Array.isArray(val?.Product_Combinations) &&
          val.Product_Combinations.length > 0 ? (
            <p>
              {val.Product_Combinations[0]?.Qty?.name} starting at ₹
              {Number(val.Product_Combinations[0]?.total || 0).toFixed(2)}
            </p>
          ) : (
            <p>
              <p>
                {val.Product?.Product_Combinations[0]?.Qty?.name} starting at ₹
                {Number(
                  val.Product?.Product_Combinations[0]?.total || 0
                ).toFixed(2)}
              </p>
            </p>
          )}
        </div>
      </Link>
    </section>
  );
}

export default Shop_by_shapes_cards;
